import { useState } from 'react'
import { Briefcase, DollarSign, Settings as SettingsIcon } from 'lucide-react'
import { cn } from '@/utils/cn'
import { useAuthStore } from '@/stores/authStore'
import { isRocketInstance } from '@/config/instanceProfile'
import { PlansTab } from './PlansTab'
import { FinanceSettingsTab } from './FinanceSettingsTab'
import { ComissoesTab } from '@/components/Comissoes'

export function FinanceiroWrapperTab() {
  const { user } = useAuthStore()
  const userRole = (user?.role || 'bdr').toLowerCase()
  const canManageFinance = userRole === 'admin' || userRole === 'manager'
  const [subTab, setSubTab] = useState<'geral' | 'planos' | 'comissoes'>(
    canManageFinance ? 'geral' : 'comissoes',
  )

  const plansLabel = isRocketInstance ? 'Serviços' : 'Planos'

  return (
    <div className="space-y-4">
      <div className="glass-card p-5">
        <div className="flex items-center gap-1 p-1 bg-white/[0.04] rounded-lg border border-white/[0.06] w-fit">
          {canManageFinance && (
            <>
              <button
                type="button"
                onClick={() => setSubTab('geral')}
                className={cn(
                  'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold whitespace-nowrap transition-all min-h-[44px]',
                  subTab === 'geral'
                    ? 'bg-accent text-white shadow-lg shadow-accent/20'
                    : 'text-text-muted hover:text-text-primary hover:bg-white/[0.06]',
                )}
              >
                <SettingsIcon size={13} /> Configurações
              </button>
              <button
                type="button"
                onClick={() => setSubTab('planos')}
                className={cn(
                  'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold whitespace-nowrap transition-all min-h-[44px]',
                  subTab === 'planos'
                    ? 'bg-accent text-white shadow-lg shadow-accent/20'
                    : 'text-text-muted hover:text-text-primary hover:bg-white/[0.06]',
                )}
              >
                <Briefcase size={13} /> {plansLabel}
              </button>
            </>
          )}
          {(canManageFinance || userRole === 'bdr' || userRole === 'closer') && (
            <button
              type="button"
              onClick={() => setSubTab('comissoes')}
              className={cn(
                'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold whitespace-nowrap transition-all min-h-[44px]',
                subTab === 'comissoes'
                  ? 'bg-accent text-white shadow-lg shadow-accent/20'
                  : 'text-text-muted hover:text-text-primary hover:bg-white/[0.06]',
              )}
            >
              <DollarSign size={13} /> Comissões
            </button>
          )}
        </div>
      </div>

      <div className="mt-4">
        {subTab === 'geral' && canManageFinance && <FinanceSettingsTab />}
        {subTab === 'planos' && canManageFinance && (
          <PlansTab catalogScope={isRocketInstance ? 'rocket' : undefined} />
        )}
        {subTab === 'comissoes' && <ComissoesTab />}
      </div>
    </div>
  )
}
